import { useEffect, useRef } from "react";

/**
 * AdSenseSlot — renders a Google AdSense responsive display ad unit.
 *
 * The base loader script is already in <head> (public/index.html).
 * This component just renders the <ins> element and pushes it to adsbygoogle.
 *
 * Usage:
 *   <AdSenseSlot slot="1234567890" />              // responsive auto-format
 *   <AdSenseSlot slot="1234567890" format="rectangle" style={{display:'inline-block', width:336, height:280}} />
 *
 * Slot IDs come from your AdSense dashboard (each ad unit you create).
 * Until you create units, the <ins> renders but shows nothing — safe.
 */
const CLIENT_ID = "ca-pub-9878338346238973";

export default function AdSenseSlot({ slot, format = "auto", responsive = true, style, className = "" }) {
  const ref = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      // AdSense not loaded yet (e.g. ad-blocker) — silently ignore
    }
  }, []);

  if (!slot) return null;

  return (
    <ins
      ref={ref}
      className={`adsbygoogle block ${className}`}
      style={style || { display: "block", minHeight: 100 }}
      data-ad-client={CLIENT_ID}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? "true" : "false"}
      data-testid={`adsense-slot-${slot}`}
    />
  );
}
